import { Navigate } from "react-router-dom";
export const ProtectedRoute = ({ RolePermission, FeaturePermission, children }) => {
    if (!RolePermission) {
        return <Navigate to={"/"} replace />
    } else if (FeaturePermission !== null) {
        if (!FeaturePermission) {
            return <Navigate to={"/"} replace />
        } else {
            return children
        }
    } else {
        return children
    }
    // return (!RolePermission || !FeaturePermission) ? <Navigate to={"/"} replace /> : children;
};